exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body>div:not(\".crisp-client\",\"#ads\"){height:100%}.topbar-info a{color:#fff;text-decoration:underline}.topbar-info a:hover{color:#fff;text-decoration:none}.top-bar-close-btn{width:20px;height:20px;background:red;color:#fff;font:20px Arial;text-align:center;display:block;position:absolute;right:0;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-9a8f98e8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/login/index/index.vue
// module id = 1142
// module chunks = 0